<div class="container mt-5">
    <p-panel header="{{'lang.page_not_found' |translate}}">
<div class="not-found-container">
    <h1>404 - {{'lang.page_not_found' |translate}}</h1>
    <p>Sorry, the page you are looking for does not exist.</p>
    <a class="link-info" (click)="goToPage()" role="button">Go {{'lang.back' |translate}}</a>
</div>
</p-panel>
</div>
<!-- page_not_found back-->